if (!customElements.get('grouped-products')) {
  class GroupedProducts extends HTMLElement {
    constructor() {
      super();
      this.okendoReviewsSectionID = null;
      this.prefetchCache = new Map(); // Cache prefetched content
    }

    connectedCallback() {
      // Find okendo reviews section id
      this.okendoReviewsSectionID = document.querySelector('[id*="okendo_reviews_widget"]')?.closest('.shopify-section')?.getAttribute('id')?.replace('shopify-section-','')

      // Attach click listeners to grouped product options
      this.querySelectorAll('.grouped-product-option').forEach((swatch) => {
        swatch.addEventListener('click', this.handleSwatchChange.bind(this));
      });

      // Prefetch all options on page load (works for both mobile and desktop)
      // Use requestIdleCallback to not block page load
      if (window.requestIdleCallback) {
        requestIdleCallback(() => this.prefetchAllOptions());
      } else {
        setTimeout(() => this.prefetchAllOptions(), 1000);
      }
    }

    prefetchAllOptions() {
      const sectionId = this.dataset.section;

      this.querySelectorAll('.grouped-product-option').forEach((swatch) => {
        const url = swatch.getAttribute('href');

        if (!url || this.prefetchCache.has(url) || swatch.classList.contains('selected')) {
          return; // Skip if already cached or currently selected
        }

        const fetchUrl = `${url}?section_id=${sectionId}`;

        // Prefetch in background with low priority
        fetch(fetchUrl, { priority: 'low' })
          .then(response => response.text())
          .then(responseText => {
            this.prefetchCache.set(url, responseText);
          })
          .catch(err => {
            // Silent fail - will fetch normally on click if prefetch fails
            console.log('Prefetch failed:', err);
          });
      });
    }

  async handleSwatchChange(e) {
    // If we're in Quick Buy, allow default navigation instead of AJAX
    const isInQuickBuy = e.currentTarget.closest('.quickbuy-container');
    if (isInQuickBuy) {
      return; // Allow the link to navigate normally
    }

    e.preventDefault();
    if (e.currentTarget.classList.contains('selected')) return;

    const url = e.currentTarget.getAttribute('href');
    const sectionId = this.dataset.section;
    if (!url) return

    // INSTANT VISUAL FEEDBACK - Update UI immediately before any work
    const clickedOption = e.currentTarget;

    // Store the previously selected option so we can revert on error
    const previouslySelected = this.querySelector('.grouped-product-option.selected');

    // 1. Update button states immediately
    this.querySelectorAll('.grouped-product-option').forEach(option => {
      option.classList.remove('selected');
    });
    clickedOption.classList.add('selected');

    // Force browser to repaint before continuing (critical for visual feedback)
    clickedOption.offsetHeight;

    // 2. Show loading overlay immediately
    const productDetail = document.querySelector('.product-detail');
    if (productDetail) {
      productDetail.classList.add('grouped-products-loading');
      // Force repaint
      productDetail.offsetHeight;
    }

    // update url
    history.replaceState({}, '', url);

    try {
      let responseText;

      // Check if we have prefetched content
      if (this.prefetchCache.has(url)) {
        // Even with prefetch, add tiny delay so user sees the visual feedback
        await new Promise(resolve => setTimeout(resolve, 100));
        responseText = this.prefetchCache.get(url);
        // Content is ready instantly - no network delay!
      } else {
        // Fallback to normal fetch if not prefetched
        let fetchUrl = `${url}?section_id=${sectionId}`;
        const response = await fetch(fetchUrl);
        responseText = await response.text();
      }

      // Remove animation attributes
      responseText = responseText.replaceAll('data-cc-animate', '')

      // Leave this commented-out, unless you want to animate the product form
      // theme.initAnimateOnScroll()

      const html = new DOMParser().parseFromString(
        responseText,
        'text/html'
      );

      let newAccessoriesBlock = html.querySelector('.add-on-accessories-block');

      // elements to update
      const sections = [
        '.product-detail',
        '.breadcrumbs-list'
      ];

      // List of elements to perserve
      // const perservedElements = '.app-block, .store-availability-container-outer'
      const perservedElements = '.upsell-theme-app-block-custom, .store-availability-container-outer'

      // Update page elements
      sections.forEach(section => {
        const responseSection = html.querySelector(section);
        const destination = document.querySelector(section);

        // Preserve some original elements within section
        const newElements = [...responseSection.querySelectorAll(perservedElements)]
        const originalElements = [...destination.querySelectorAll(perservedElements)]
        for (let i = 0; i < newElements.length; i++) {
          newElements[i].replaceWith(originalElements[i])
        }

        // Replace entire section html
        if (responseSection && destination) {
          destination.replaceWith(responseSection)
        }
      })

      // Remove loading overlay - content is ready
      const newProductDetail = document.querySelector('.product-detail');
      if (newProductDetail) {
        newProductDetail.classList.remove('grouped-products-loading');
      }

      // apply class to <main> element to override styles
      document.querySelector('main').classList.add('grouped-products-view')

      // reinit add to cart form
      // Unload before reloading to prevent handler stacking
      $('.product-form').trigger('unload-product-form');
      $('.product-form').trigger('load-product-form');

      // reinit gallery
      const componentContainer = document.querySelector('[data-section-type="main-product"]')
      theme.initProductGallery(componentContainer);

      // reinit other componenets
      $(componentContainer).closest('[data-components]').each(function () {
        $(this).data('components').split(',').forEach((component) => {
          $(document).trigger('cc:component:load', [component, componentContainer]);
        });
      });

      // update local pickup popup title
      const newProductTitle = document.querySelector('.product-form')?.querySelector('.title')?.textContent
      if(newProductTitle && document.querySelector('#store-availabilities-modal__product-title')) {
        document.querySelector('#store-availabilities-modal__product-title').textContent = newProductTitle
      }

      // Dispatch custom event to trigger slider reinitialization in minicart quickbuy
      const minicartQuickbuy = document.querySelector('.minicart-quickbuy-container.open');
      document.dispatchEvent(new CustomEvent('grouped-products:content-updated', {
        detail: {
          isMinicartQuickbuy: !!minicartQuickbuy,
          minicartContainer: minicartQuickbuy
        },
        bubbles: true
      }));

      // update accessories block
      let accessoriesBlock = document.querySelector('.add-on-accessories-block');
      if(accessoriesBlock) {

        if(newAccessoriesBlock) {
          // replace accessories block
          accessoriesBlock.replaceWith(newAccessoriesBlock);

          setTimeout(() => {
            // reload product-addon-js
            // reload product-upsell-slider-js
            reinitializeAfterFetch();

            // Trigger lazy loading for newly loaded images
            const newAccessoriesBlock = document.querySelector('.add-on-accessories-block');
            if (newAccessoriesBlock) {
              // Initialize product block manager for image handling
              if (typeof window.theme !== 'undefined' && window.theme.ProductBlockManager) {
                window.theme.ProductBlockManager.loadImages(newAccessoriesBlock);
              }
            }
          }, 1000);
        }
      }


      // reinit Klaviyo back in stock
      this.loadAndInitKlaviyoBackInStock();

      // update okendo reviews widget
      const okendoResponse = await fetch(`${url}?section_id=${this.okendoReviewsSectionID}`);
      let okendoResponseText = await okendoResponse.text();
      const okendoHtml = new DOMParser().parseFromString(
        okendoResponseText,
        'text/html'
      );
      const newOkendoReviews = okendoHtml.querySelector('[id*="okendo_reviews_widget"]')
      const currentOkendoReviews = document.querySelector('[id*="okendo_reviews_widget"]')
      if (newOkendoReviews && currentOkendoReviews) {
        currentOkendoReviews.replaceWith(newOkendoReviews)
      }

    } catch (error) {
      console.error('Error within grouped-products.js:', error);

      // Reset UI on error
      const errorProductDetail = document.querySelector('.product-detail');
      if (errorProductDetail) {
        errorProductDetail.classList.remove('grouped-products-loading');
      }

      // Revert button state to previously selected option
      this.querySelectorAll('.grouped-product-option').forEach(option => {
        option.classList.remove('selected');
      });
      if (previouslySelected) {
        previouslySelected.classList.add('selected');
      }

      // Optionally show an error message to the user
      console.warn('Failed to switch product variant');
    }
  }

  loadAndInitKlaviyoBackInStock() {
    // Initialize Klaviyo
    var klaviyo = window.klaviyo || [];
    klaviyo.init({
      account: "HKDrrQ",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{
      trigger: {
        product_page_text: "Notify Me When Available",
        product_page_class: "button",
        product_page_text_align: "center",
        product_page_margin: "0px",
        replace_anchor: false
      },
      modal: {
      headline: "{product_name}",
      body_content: "We'll notify you when this style is back in stock.",
      email_field_label: "Email",
      button_label: "Email Me When Available",
      subscription_success_label: "You're in! We'll let you know when it's back.",
      footer_content: '',
      additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
      drop_background_color: "#000",
      background_color: "#fff",
      text_color: "#222",
      button_text_color: "#fff",
      button_background_color: "#ff9280",
      close_button_color: "#ccc",
      error_background_color: "#fcd6d7",
      error_text_color: "#C72E2F",
      success_background_color: "#d3efcd",
      success_text_color: "#1B9500"
      }
    });
  }
}

  customElements.define('grouped-products', GroupedProducts);
}